import { gql, graphQueryBang } from "shared/lib/graphql"
import { topServicesMapper } from "./gql_data_mapper"

export const worksWithFragment = `
  works_with_channel {
    name
    module_name
    brand_color
    monochrome_image_url
  }
  metrics {
    metric_date
    active_users_TIME_PERIOD
    service_engagement_daily
    active_users_all_time
  }
`

const topWorksWithServicesQuery = gql`
  query(
    $service: String!
    $current_metric_date: DataServiceDate!
    $comparison_metric_date: DataServiceDate!
    $limit: Int
  ) {
    current: service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
    ) {
      metrics {
        metric_date
        first_time_service_connections_in_TIME_PERIOD
        first_time_service_connections_all_time
        top_works_with_services_TIME_PERIOD(limit: $limit) {
          works_with_channel {
            module_name
          }
        }
      }
    }
    comparison: service_metrics(
      channel_module_name: $service
      metric_start_date: $comparison_metric_date
      metric_end_date: $comparison_metric_date
    ) {
      metrics {
        metric_date
        first_time_service_connections_in_TIME_PERIOD
        first_time_service_connections_all_time
      }
    }
  }
`

const singleWorksWithQuery = gql`
  query(
    $service: String!
    $works_with_channel_name: String
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${worksWithFragment}
      }
      errors {
        attribute
        message
      }
    }
  }
`

const composedTopWorksWithQuery = timePeriodMetric =>
  topWorksWithServicesQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

const composedWorksWithQuery = timePeriodMetric =>
  singleWorksWithQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function topServicesFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  {
    dailyMetricStartDate,
    currentMetricDate,
    comparisonMetricDate,
    timePeriodInDays,
    timePeriodMetric,
    limit,
  }
) {
  const servicesP = graphQueryBang(
    composedTopWorksWithQuery(timePeriodMetric),
    {
      service: serviceModuleName,
      works_with_channel_module_name: worksWithChannelName,
      comparison_metric_date: comparisonMetricDate,
      current_metric_date: currentMetricDate,
      limit,
    }
  )

  const topWWServicesP = servicesP
    .then(data =>
      data.current.metrics[0][
        `top_works_with_services_${timePeriodMetric}`
      ].map(tww => tww.works_with_channel.module_name)
    )
    .then(topWorksWithServices =>
      Promise.all(
        topWorksWithServices.map(worksWithService =>
          graphQueryBang(composedWorksWithQuery(timePeriodMetric), {
            service: serviceModuleName,
            works_with_channel_name: worksWithService,
            daily_metric_start_date: dailyMetricStartDate,
            current_metric_date: currentMetricDate,
          })
        )
      )
    )

  return Promise.all([servicesP, topWWServicesP]).then(values => {
    const [serviceMetrics, worksWithMetrics] = values

    return topServicesMapper(
      {
        works_with_metrics: worksWithMetrics.map(
          ww => ww.daily.works_with_metrics[0]
        ),
        current: serviceMetrics.current,
        comparison: serviceMetrics.comparison,
      },
      timePeriodInDays,
      currentMetricDate,
      comparisonMetricDate,
      timePeriodMetric
    )
  })
}
